// Metrics Enum
import get from 'lodash/get';
import invert from 'lodash/invert';

import { metricCategory } from './adContent/metricCategory';
import METRIC from './metricKeys';

const product = window.conviva.module || 'Activation';

/*
  reverse: Generally, increase on the metric value is a good sign. Set reverse to true if it's not.
 *
*/
export const metricsMeta = {
  Activation: {
    [METRIC.AppTotalUserEvents]: {
      name: METRIC.AppTotalUserEvents,
      displayName: 'Total Events',
      ovbDisplayName: 'Total Events',
      short: 'Total Events',
      ovbShort: 'Total Events',
      subscript: '',
      active: true,
      calcPercentage: true,
      unit: '',
      sortBy: true,
      helpText: 'Total Events.',
      category: metricCategory.STARTUP,
    },
  },
};

// Metric line charts in Metrics Container
const METRICS_DEFAULT_ORDER = {
  Activation: [METRIC.AppTotalUserEvents],
};

// Special behavior for the following metrics
// Metrics Panel - Shows Percentage metric version of the metric
// Dimension Tables - Show non-percentage metric
// Diagnostics Chart - Shows Percentage metric version of the metrics
// Redux store : metricsContainer.selectedMetric - Always shows non-percentage metric
// It is upto each container to convert the metrics from the store the metric that is needed
// to show for that container
const METRIC_SWITCH_MAP = {
  [METRIC.AppTotalUserEvents]: METRIC.AppTotalUserEvents,
};
const INVERTED_METRIC_SWITCH_MAP = invert(METRIC_SWITCH_MAP);

const ACTIVE_METRICS = {
  Activation: Object.entries(metricsMeta.Activation)
    .filter(([, attr]) => attr.active)
    .reduce((prevObj, [name, attr]) => ({ ...prevObj, [name]: attr }), {}),
};

const SORT_BY_METRICS = {
  Activation: Object.entries(metricsMeta.Activation)
    .filter(([, attr]) => attr.sortBy)
    .reduce((prevObj, [name, attr]) => ({ ...prevObj, [name]: attr }), {}),
};

const ALL_METRICS = metricsMeta;

/**
 * https://beacon.corp.conviva.com/display/dev/Instant+Filter+Phase+2+Functional+Spec
 * TP-10
 */
const PERCENTAGE_METRICS = {
  Activation: Array.from(new Set([METRIC.AppTotalUserEvents])),
};

const getMetricDisplayName = (metric) => get(ALL_METRICS[product], `${metric}.displayName`);
const getMetricShortName = (metric) => get(ALL_METRICS[product], `${metric}.short`);
const shouldCalcPercentage = (metric) => get(ALL_METRICS[product], `${metric}.calcPercentage`);
const getMetricUnit = (metric) => get(ALL_METRICS[product], `${metric}.unit`);

const DEFAULT_CHART_METRICS = {
  Activation: [METRIC.AppTotalUserEvents],
}[product];

const METRIC_LIST = ALL_METRICS[product];

export {
  METRIC,
  ACTIVE_METRICS as METRICS,
  ALL_METRICS,
  SORT_BY_METRICS,
  METRICS_DEFAULT_ORDER,
  METRIC_SWITCH_MAP,
  INVERTED_METRIC_SWITCH_MAP,
  PERCENTAGE_METRICS,
  getMetricDisplayName,
  getMetricShortName,
  shouldCalcPercentage,
  getMetricUnit,
  DEFAULT_CHART_METRICS,
  METRIC_LIST,
};
